<!-- ════════════════════════════════════════════════════════════════
     V3 DESIGN — Job Profile Detail (Details tab content only)
     Header is now rendered in the parent (new-job.component.html)
     ════════════════════════════════════════════════════════════════ -->
<ng-container *ngIf="designVersion === 'v3' && jobDetails?.jobId != null">
  <!-- Job Details + Description (shown on Details tab) -->
  <div class="jc-v3-tab-content">
    <div class="jc-v3-detail-grid">
      <div class="jc-v3-detail-card">
        <h4>Job Details</h4>
        <div class="jc-v3-detail-row">
          <span class="jc-v3-d-label">Primary Skills</span>
          <span class="jc-v3-d-val">{{ jobDetails?.primarySkills?.join(', ') || '–' }}</span>
        </div>
        <div class="jc-v3-detail-row">
          <span class="jc-v3-d-label">Secondary Skills</span>
          <span class="jc-v3-d-val">{{ jobDetails?.secondarySkills?.join(', ') || '–' }}</span>
        </div>
        <div class="jc-v3-detail-row">
          <span class="jc-v3-d-label">Experience</span>
          <span class="jc-v3-d-val">{{ jobDetails?.experienceFrom }} to {{ jobDetails?.experienceTo }} years</span>
        </div>
        <div class="jc-v3-detail-row">
          <span class="jc-v3-d-label">Work Mode</span>
          <span class="jc-v3-d-val">{{ jobDetails?.workMode || '–' }}</span>
        </div>
        <div class="jc-v3-detail-row">
          <span class="jc-v3-d-label">Engagement Type</span>
          <span class="jc-v3-d-val">{{ jobDetails?.jobClassification || '–' }}</span>
        </div>
      </div>
      <div class="jc-v3-detail-card">
        <h4>Activity Summary</h4>
        <div class="jc-v3-detail-row">
          <span class="jc-v3-d-label">Total Views</span>
          <span [title]="jobDetails?.viewedByCount + ' Views'" class="jc-v3-d-val">{{ jobDetails?.viewedByCount | compactCount }}</span>
        </div>
        <div class="jc-v3-detail-row">
          <span class="jc-v3-d-label">Total Likes</span>
          <span [title]="jobDetails?.likesCount + ' Likes'" class="jc-v3-d-val">{{ jobDetails?.likesCount | compactCount }}</span>
        </div>
        <div class="jc-v3-detail-row">
          <span class="jc-v3-d-label">Total Applicants</span>
          <span [title]="jobDetails?.appliedCount + ' Applied'" class="jc-v3-d-val">{{ jobDetails?.appliedCount | compactCount }}</span>
        </div>
        <div class="jc-v3-detail-row">
          <span class="jc-v3-d-label">Posted Date</span>
          <span class="jc-v3-d-val">{{ jobDetails?.updatedOn | timezoneDate:'MM/dd/yyyy' }}</span>
        </div>
      </div>
    </div>
    <div class="jc-v3-desc-card">
      <h4>Job Description</h4>
      <div [ngxSummernoteView]="jobDetails?.jobDescription" style="word-wrap:break-word;"></div>
    </div>
  </div>

  <app-job-template [showtoggle]="showToggleValue" (jobReload)="reloadJobData($event)"></app-job-template>

  <ng-template #candidateSupplyTemplate>
    <ng-container>
      <div class="row mr-0">
        <div class="col-sm-8 pad-lt-rt-0">
          <div class="xs-heading-flex-parent">
            <div class="xs-heading-entity">My Candidates</div>
            <div class="xs-heading-payrate">Pay Rate</div>
            <div class="xs-heading-paytype">Type</div>
          </div>
          <div class="xs-body-container" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="300"
            [scrollWindow]="false" (scrolled)="onCandidateSupplyScroll()">
            <div #candidatesPageContainer id="candidatesPageDynamicContainerJobProfileDetail"></div>
          </div>
          <div class="xs-footer-container"></div>
        </div>
        <div class="col-sm-4 pad-lt-0 pad-rt-0">
          <div class="hpanel"  style="margin-bottom: 0px !important;border-radius: 20px 9px 9px 20px !important;">
            <div class="hpanel-heading xs-heading-flex-entity-detail">
              <div>Job Details</div>
              <button><span class="modalai-close" aria-hidden="true" (click)="closeCandidateSupplyModal()">&times;</span></button>
            </div>
            <app-job-submit-skillfilter [focus]="'job'" [jobData]="jobData" [termsChecked]="termsCheck" [resumes]="resumeData"
              [formData]="rtrFormData" [dataPasstoSkillwidgets]="dataPasstoSkillwidgets"
              (emitRemoveTag)="removeUserfromTag($event)">
            </app-job-submit-skillfilter>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #connectionTemplate>
    <app-connection-template [page]="'job-profile-pop-up'" [connectionStatus]="connectionStatus"
      [counterpartsDetails]="counterpartsDetails" [values]="values" [module]="'job'"></app-connection-template>
  </ng-template>
</ng-container>

<!-- ════════════════════════════════════════════════════════════════
     V2 DESIGN (existing) — Job Profile Detail Header
     ════════════════════════════════════════════════════════════════ -->
<div [ngClass]="{'sub-entities-scroll-container-1': !isInSlider}" *ngIf="designVersion !== 'v3' && jobDetails?.jobId != null">
  <div class="hpanel">
    <div class="panel-body br-bt-none border-radius-top-left-right-0">
      <div class="card-details">
        <div class="row">
          <div class="col-sm-5 flex-row-center" *ngIf="jobDetails?.user?.userType!='FREELANCE_RECRUITER'">
              <img *ngIf="jobDetails?.user?.workExperience?.length && !jobDetails?.user?.workExperience[0]?.businessLogo"
                class="normal-image" src="assets/images/gallery/company.png" alt="Business Logo">

              <img *ngIf="jobDetails?.user?.workExperience?.length && jobDetails?.user?.workExperience[0]?.businessLogo"
                class="normal-image" [src]="url + jobDetails?.user?.workExperience[0]?.businessLogo" alt="Object Photo">

              <ng-container *ngFor="let experience of jobDetails?.user?.workExperience; let i = index;">
                <div *ngIf="experience?.currentOrganization">
                  {{ experience?.organisationName }}
                  <ng-icon name="tablerStar"></ng-icon>
                </div>
            </ng-container>
          </div>
          <div class="col-sm-5 flex-row-center" *ngIf="jobDetails?.user?.userType=='FREELANCE_RECRUITER'">
            <div *ngFor="let experience of jobDetails?.user?.workExperience; let i = index;">
              <div *ngIf="jobDetails.jobPostedBehalfOf == experience.organisationName">
                <img *ngIf="experience?.businessLogo==null" class="normal-image" src="assets/images/gallery/company.png"
                  alt="Business Logo">
                <img *ngIf="experience?.businessLogo!=null" class="normal-image" [src]="url+experience?.businessLogo"
                  alt="Object Photo">
              </div>
            </div>
            <ng-container *ngFor="let experience of jobDetails?.user?.workExperience; let i = index;">
              <div *ngIf="jobDetails.jobPostedBehalfOf == experience.organisationName">
                {{ jobDetails?.jobPostedBehalfOf }}
                <ng-icon name="tablerStar"></ng-icon>

              </div>
            </ng-container>
          </div>
          <div class="col-sm-7 p-0 justify-content-left flex">
            <app-connection-template [page]="'job-profile'" [connectionStatus]="jobDetails?.connectionStatus"
              [counterpartsDetails]="jobDetails?.user" [values]="jobDetails" [module]="'job'"></app-connection-template>
          </div>
        </div>
        <hr>
        <div class="row">
          <div class="card-item-2">
            <div class="col-sm-12 flex-1rem-top pad-0">
              <div class="col-sm-10">
                <div class="dp-flx">
                  <h4 class="p-0">
                    {{jobDetails?.jobTitle | truncate: 26}}
                  </h4>

                  <div class="active-label sts-lbl" *ngIf="jobDetails?.status == 'ACTIVE'">Active</div>
                  <div class="draft-label sts-lbl" *ngIf="jobDetails?.status == 'DRAFTED'">Draft</div>
                  <div class="inactive-label sts-lbl" *ngIf="jobDetails?.status == 'INACTIVE'">Inactive</div>
                  <div class="onhold-label sts-lbl" *ngIf="jobDetails?.status == 'ON HOLD'">On Hold</div>
                  <div class="filled-label-1 sts-lbl" *ngIf="jobDetails?.status == 'FILLED'">Filled</div>
                  <div class="closed-label sts-lbl" *ngIf="jobDetails?.status == 'CLOSED'">Closed</div>
                  <div class="blocked-label sts-lbl" *ngIf="jobDetails?.status == 'BLOCKED'">Blocked</div>

                  <div class="subcontracted-label sts-lbl" *ngIf="subContractedByName"
                       [title]="'SubContracted by ' + subContractedByName">
                    SubContracted by <span class="sc-name">{{ subContractedByName }}</span>
                  </div>
                </div>

                <div class="flex-left">
                  <ng-icon name="tablerCalendar" class="svg-position"></ng-icon>
                  <p class="mr-0">
                    Created On
                  </p>
                  <p class="mr-0">
                    {{jobDetails?.updatedOn | timezoneDate:'MM/dd/yyyy'}}
                  </p>
                  <p class="mr-0" *ngIf="jobDetails?.jobReferenceId">
                    |
                  </p>
                  <p class="mr-0">
                    Job ID: {{jobDetails?.jobReferenceId}}
                  </p>
                </div>
                <div class="urgent-hire-container" *ngIf="getActiveUrgencyDays(jobDetails) as urgencyDays" style="margin-top: 4px;">
                  <span class="urgent-hire-badge"><ng-icon name="tablerFlame" class="urgent-hire-icon"></ng-icon> Urgent Hire</span>
                  <span class="urgent-hire-countdown">Urgency ends in {{urgencyDays}} day{{urgencyDays === 1 ? '' : 's'}}</span>
                </div>
              </div>
              <div class="col-sm-2 pr-0 job-profile-action-container">
                <div *ngIf=" jobDetails?.jobPostedBy!=userId && (userType == 'BENCH_RECRUITER'
                || userType == 'student' || userType == 'JOB_SEEKER' || userType == 'FREELANCE_RECRUITER'
                || userType == 'MANAGEMENT_TALENT_ACQUISITION')">
                  <button id="job_detail_apply_button" title="Apply" class="btn-primary btn"  style="color:#fff !important;"
                    [ngClass]="{disabled : !jobDetails?.availability || jobDetails?.status != 'ACTIVE' }"
                    (click)="apply(jobDetails, connectionTemplate, candidateSupplyTemplate)">Apply</button>
                </div>

                <div [ngClass]="{'disabled': toggleOpen  }" *ngIf="jobDetails?.status != 'BLOCKED'">
                  <label class="jp-toggle">
                    <input id="toogleBar"
                      [disabled]="(  jobDetails?.status == 'FILLED' || jobDetails?.status == 'CLOSED'||jobDetails?.status == 'DRAFTED') || jobDetails?.jobPostedBy != userId  "
                      (click)="enableJob($event)" [ngModel]="jobDetails?.status == 'ACTIVE'"
                      [ngModelOptions]="{standalone: true}" type="checkbox">
                    <span [ngClass]="jobDetails?.jobPostedBy != userId ? 'jp-toggle-track jp-toggle-hidden' : 'jp-toggle-track'"></span>
                  </label>
                </div>

                <div class="btn-group"
                  *ngIf="jobDetails?.jobPostedBy === userId && jobDetails?.status != 'FILLED' && jobDetails?.status != 'CLOSED' && jobDetails?.status != 'BLOCKED'"
                  dropdown container="body" [isOpen]="moreActionsOpen" (isOpenChange)="onMoreActionsToggle($event)">
                  <a dropdownToggle class="job-detail-more-btn" title="More actions" (click)="$event.stopPropagation()">
                    <ng-icon name="tablerDotsVertical"></ng-icon>
                  </a>
                  <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu">
                    <li role="menuitem">
                      <a class="dropdown-item" (click)="editJob(jobDetails)">
                        <ng-icon name="tablerEdit" style="margin-right:6px;"></ng-icon>Edit
                      </a>
                    </li>
                    <li role="menuitem" *ngIf="jobDetails?.status === 'ACTIVE'">
                      <a class="dropdown-item" (click)="republishJob()">
                        <ng-icon name="tablerRefresh" style="margin-right:6px;"></ng-icon>Republish
                      </a>
                    </li>
                    <li role="menuitem"
                      *ngIf="jobDetails?.status !== 'INACTIVE' && jobDetails?.status !== 'DRAFTED' && jobDetails?.status !== 'ON HOLD' && jobDetails?.status !== 'FILLED' && !jobDetails?.isFeatured">
                      <a class="dropdown-item" (click)="featurejobvalues()">
                        <ng-icon name="tablerCircleArrowUp" style="margin-right:6px;"></ng-icon>Upgrade
                      </a>
                    </li>
                  </ul>
                </div>
                <div *ngIf="showSubContractButton">
                  <button class="btn btn-outline-primary btn-sm" (click)="openSubContractModal()">
                    {{ jobDetails?.subContractStatus === 'PUBLISHED' ? 'Edit Sub-Contract' : 'Sub-Contract Job' }}
                  </button>
                </div>
              </div>
            </div>
            <div class="col-sm-12 flex-1rem-center">
              <ng-icon name="tablerMapPin" class="svg-position"></ng-icon>
              {{ gigsumoService.formatLocation(jobDetails?.city, jobDetails?.state, jobDetails?.country) }}
            </div>
          <div class="col-sm-12 flex-1rem-center" [title]="(jobDetails?.targetRateFrom && jobDetails?.targetRateTo) ?
                    ('Employer Estimate: ' + jobDetails?.targetRateFrom + ' - ' + jobDetails?.targetRateTo + ' ' + getJobCurrency(jobDetails) + ' / ' + getPayType(jobDetails?.payType)) :
                    'Employer Estimate: Not available'">
            <ng-icon name="tablerCurrencyDollar" class="svg-position"></ng-icon>
            Employer Estimate:
            <ng-container *ngIf="jobDetails?.targetRateFrom && jobDetails?.targetRateTo; else noRateDetail">
              <span>{{jobDetails?.targetRateFrom}} - {{jobDetails?.targetRateTo}}</span>
              <span>{{getJobCurrency(jobDetails)}} / {{getPayType(jobDetails?.payType)}}</span>
            </ng-container>
            <ng-template #noRateDetail><span>Not available</span></ng-template>
          </div>

          <!-- Candidate-Specific Applied Rate - Only shown in slider -->
          <div class="col-sm-6 flex-1rem-center" *ngIf="candidateSpecificDetails && isInSlider"
               style="background: linear-gradient(135deg, #f0f8ff 0%, #e6f3ff 100%);
                      padding: 12px 15px;
                      border-radius: 8px;
                      margin: 10px 0;
                      box-shadow: 0 2px 4px rgba(139, 92, 246, 0.1);">
            <ng-icon name="tablerCurrencyDollar" class="svg-position"  style="color: #8B5CF6;"></ng-icon>
            <strong style="color: #8B5CF6; margin-right: 8px;">Applied for:</strong>
            <span>
              {{candidateSpecificDetails.targetRate}} {{getJobCurrency(jobDetails)}} / {{candidateSpecificDetails.payType}}
            </span>
          </div>

            <div class="col-sm-12 flex-1rem-center flex-wrap">
              <ng-icon name="tablerBuilding" *ngIf="jobDetails?.showClientType" class="svg-position"></ng-icon>
              <span *ngIf="jobDetails?.showClientType">Position with {{jobDetails?.clientType}}</span>
              <ng-icon name="tablerBuilding" *ngIf="jobDetails?.showClientName" class="svg-position"></ng-icon>
              <span *ngIf="jobDetails?.showClientName">{{jobDetails?.clientName}}</span>
              <ng-icon name="tablerBriefcase" *ngIf="jobDetails?.jobClassification" class="svg-position"></ng-icon>
              <span *ngIf="jobDetails?.jobClassification">{{jobDetails?.jobClassification}}</span>
            </div>
            <div class="col-sm-12 dp-flx-5">
              <div class="innerflex br-pd" [ngClass]="{'active-label': jobDetails?.workMode}">
                 <ng-icon name="tablerCheck" *ngIf="jobDetails?.workMode" class="svg-position"></ng-icon>
                <span> {{jobDetails?.workMode}} </span>
              </div>
              <!-- <div class="innerflex br-pd" [ngClass]="{'active-label': jobDetails?.workMode=='Onsite', 'inactive-label': jobDetails?.workMode!='Onsite'}">
                <ng-icon name="tablerX" *ngIf="jobDetails?.workMode!='Onsite'" class="svg-position"></ng-icon>
                <ng-icon name="tablerCheck" *ngIf="jobDetails?.workMode=='Onsite'"  class="svg-position"></ng-icon>
                <span> Onsite </span>
              </div>
              <div class="innerflex br-pd" [ngClass]="{'active-label': jobDetails?.workMode=='Remote', 'inactive-label': jobDetails?.workMode!='Remote'}">
                <ng-icon name="tablerX" *ngIf="jobDetails?.workMode!='Remote'" class="svg-position"></ng-icon>
                <ng-icon name="tablerCheck" *ngIf="jobDetails?.workMode=='Remote'" class="svg-position"></ng-icon>
                <span> Remote </span>
              </div> -->
              <div class="innerflex br-pd" [ngClass]="{'active-label': jobDetails?.securityClearance, 'inactive-label': !jobDetails?.securityClearance}">
                <ng-icon name="tablerX" *ngIf="!jobDetails?.securityClearance" class="svg-position"></ng-icon>
                <ng-icon name="tablerCheck" *ngIf="jobDetails?.securityClearance" class="svg-position"></ng-icon>
                <span>Securiy Clearance</span>
              </div>
            </div>

          </div>

        </div>

        <hr>

        <div class="row ">
          <div class="card-item-2">
            <h5 class="col-sm-12 fw-bold">
              Job Details
            </h5>

            <div class="col-sm-12 flex-1rem-center">
              <div class="col-sm-4 pad-0">Primary Skills</div>
              <div class="col-sm-8 p-0 flex-gap-1" style="flex-wrap: wrap !important;">
                <div title="{{item}}" class="skills-container" *ngFor="let item of jobDetails?.primarySkills">
                  {{item}}
                </div>
              </div>
            </div>
            <div class="col-sm-12 flex-1rem-center">
              <div class="col-sm-4 pad-0">Secondary Skills</div>
              <div class="col-sm-8 p-0 flex-gap-1" style="flex-wrap: wrap !important;">
                <ng-container *ngIf="jobDetails?.secondarySkills?.length; else emptySkills">
                  <div
                    title="{{ item }}"
                    class="skills-container"
                    *ngFor="let item of jobDetails?.secondarySkills"
                  >
                    {{ item }}
                  </div>
                </ng-container>
                <ng-template #emptySkills>
                  <div class="col-sm-12 text-muted">_</div>
                </ng-template>
              </div>
            </div>
            <div class="col-sm-12 flex-1rem-center">
              <div class="col-sm-4 pad-0">Experience </div>
              <div class="col-sm-8 p-0"> {{jobDetails?.experienceFrom}} to {{jobDetails?.experienceTo}} years</div>
            </div>
          </div>
        </div>

        <hr>

        <div class="row">
          <div class="card-item-2">
            <h5 class="col-sm-12 fw-bold">
              Job Description
            </h5>
            <div class="col-sm-12">
              <div class="wrap-break" style="word-wrap: break-word;" [ngxSummernoteView]="jobDetails?.jobDescription">
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

  <app-job-template [showtoggle]="showToggleValue" (jobReload)="reloadJobData($event)"></app-job-template>

  <ng-template #candidateSupplyTemplate>
    <ng-container>
      <div class="row mr-0">
        <div class="col-sm-8 pad-lt-rt-0">
          <div class="xs-heading-flex-parent">
            <div class="xs-heading-entity">My Candidates</div>
            <div class="xs-heading-payrate">Pay Rate</div>
            <div class="xs-heading-paytype">Type</div>
          </div>
          <div class="xs-body-container" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="300"
            [scrollWindow]="false" (scrolled)="onCandidateSupplyScroll()">
            <!-- Dynamic component container for CandidatesPageComponent (circular dependency fix) -->
            <!-- Using div with ID so we can query it from the modal's DOM after modal renders -->
            <div #candidatesPageContainer id="candidatesPageDynamicContainerJobProfileDetail"></div>
          </div>
          <div class="xs-footer-container"></div>
        </div>
        <div class="col-sm-4 pad-lt-0 pad-rt-0">
          <div class="hpanel" style="margin-bottom: 0px !important;border-radius: 20px 9px 9px 20px !important;">
            <div class="hpanel-heading xs-heading-flex-entity-detail">
              <div>Job Details</div>
                <button><span class="modalai-close" aria-hidden="true" (click)="closeCandidateSupplyModal()">&times;</span></button>
            </div>
            <app-job-submit-skillfilter [focus]="'job'" [jobData]="jobData" [termsChecked]="termsCheck" [resumes]="resumeData"
              [formData]="rtrFormData" [dataPasstoSkillwidgets]="dataPasstoSkillwidgets"
              (emitRemoveTag)="removeUserfromTag($event)">
            </app-job-submit-skillfilter>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #connectionTemplate>
    <app-connection-template [page]="'job-profile-pop-up'" [connectionStatus]="connectionStatus"
      [counterpartsDetails]="counterpartsDetails" [values]="values" [module]="'job'"></app-connection-template>
  </ng-template>
</div>
